module.exports = __webpack_public_path__ + "static/media/Picture7.32c592ee.png";